import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const RconProTips = () => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  return (
    <section className="pro-tips-section">
      <div className="pro-tips-heading">
        <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8">
          <circle cx="12" cy="12" r="10" />
          <circle cx="12" cy="12" r="3" fill="currentColor" />
        </svg>
        <span>
          {isEn ? 'EXPERT RECOMMENDATIONS • PRO TIPS' : 'РЕКОМЕНДАЦИИ ЭКСПЕРТОВ • PRO TIPS'}
        </span>
      </div>

      <div className="tips-grid">
        {/* Tip 1 */}
        <div className="tip-card">
          <div className="tip-backdrop-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
              <rect width="18" height="18" x="3" y="3" rx="2" />
              <path d="m9 8 6 4-6 4Z" />
            </svg>
          </div>
          <div className="tip-card-inner">
            <div className="tip-icon-header">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <rect width="18" height="18" x="3" y="3" rx="2" />
                <path d="m9 8 6 4-6 4Z" />
              </svg>
            </div>
            <h4 className="tip-title">
              {isEn ? 'Common RCON Ports' : 'Общие порты RCON'}
            </h4>
            <p className="tip-description">
              {isEn ? (
                <>Most servers use port <strong>25575</strong> for RCON by default. Checking the adjacent <strong>25576–25580</strong> range often reveals test instances or backup developer management panels.</>
              ) : (
                <>Большинство серверов используют порт <strong>25575</strong> для RCON по умолчанию. Проверка смежного диапазона <strong>25576–25580</strong> часто выявляет тестовые инстансы или резервные панели управления разработчиков.</>
              )}
            </p>
          </div>
        </div>

        {/* Tip 2 */}
        <div className="tip-card">
          <div className="tip-backdrop-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
              <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
          </div>
          <div className="tip-card-inner">
            <div className="tip-icon-header">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
            </div>
            <h4 className="tip-title">
              {isEn ? 'Password Strategy' : 'Стратегия паролей'}
            </h4>
            <p className="tip-description">
              {isEn ? (
                <>Start with variations of the server name, then common Minecraft passwords, then standard dictionaries. The intelligent StormBlack mutator automatically generates combinations from hostname, year and suffixes.</>
              ) : (
                <>Начните с вариаций названия сервера, затем общих паролей Minecraft, затем стандартных словарей. Умный мутатор StormBlack автоматически генерирует комбинации из имени хоста, года и суффиксов.</>
              )}
            </p>
          </div>
        </div>

        {/* Tip 3 */}
        <div className="tip-card">
          <div className="tip-backdrop-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
          </div>
          <div className="tip-card-inner">
            <div className="tip-icon-header">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
            </div>
            <h4 className="tip-title">
              {isEn ? 'Patience is Key' : 'Терпение — ключ к успеху'}
            </h4>
            <p className="tip-description">
              {isEn ? (
                <>RCON audit takes time. Moderate thread counts (20–30) and sensible request delays lower the risk of detection by hosting anti-brute modules and prevent premature IP rate limiting.</>
              ) : (
                <>Аудит RCON может занять время. Более высокие значения задержки и умеренное количество потоков (20–30) снижают риск обнаружения анти-брутфорс модулями хостинга и защищают от преждевременного IP-бана.</>
              )}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RconProTips;
